export function toTitleCase(str: string) {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Convert camelCase to space-separated words
    .replace(/_/g, ' ') // Convert snake_case to space-separated words
    .replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}